{
	"title": "Smluvní podmínky",
	"backTitle": "Zpět"
}
